function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useFormikContext } from "formik";
import { isEqual } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useInterval } from "react-use";
var isNamedElement = function(target) {
    return _instanceof(target, HTMLElement) && 'name' in target;
};
var StyledFormAutosaveObserver = styled('span')(function() {
    return {
        display: 'contents'
    };
});
export var FormAutosaveObserver = function(_param) {
    var _param_interval = _param.interval, interval = _param_interval === void 0 ? 5000 : _param_interval, props = _object_without_properties(_param, [
        "interval"
    ]);
    var _props_children;
    var observerRef = useRef(null);
    var formikCtx = useFormikContext();
    var _useState = _sliced_to_array(useState({
        disabled: !!props.disabled,
        error: null,
        isSaving: false,
        previous: formikCtx.initialValues,
        savedAt: null
    }), 2), meta = _useState[0], setMeta = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), focused = _useState1[0], setFocused = _useState1[1];
    useEffect(function() {
        setMeta(_object_spread_props(_object_spread({}, meta), {
            disabled: formikCtx.isSubmitting || !!props.disabled
        }));
    }, [
        props.disabled,
        formikCtx.isSubmitting
    ]);
    var getStaged = useCallback(function() {
        return Object.keys(formikCtx.values).reduce(function(acc, field) {
            var _focused_match;
            return _object_spread_props(_object_spread({}, acc), _define_property({}, field, formikCtx.errors[field] || field === (focused === null || focused === void 0 ? void 0 : (_focused_match = focused.match(/^[a-zA-Z0-9]+/)) === null || _focused_match === void 0 ? void 0 : _focused_match[0]) ? meta.previous[field] : Array.isArray(formikCtx.values[field]) ? formikCtx.touched[field] ? formikCtx.values[field].filter(function(row) {
                return Object.values(row).some(Boolean);
            }) : formikCtx.initialValues[field] : formikCtx.values[field]));
        }, {});
    }, [
        formikCtx.errors,
        formikCtx.initialValues,
        formikCtx.touched,
        formikCtx.values,
        focused,
        meta.previous
    ]);
    var save = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var staged, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    // prevent attempting a new save while one is already happening
                    if (meta.isSaving) {
                        return [
                            2,
                            false
                        ];
                    }
                    // lists in nested fields will NOT be treated as FormListBuilder lists
                    // eg: `companies[0].employees` will not filter empty rows when saving
                    staged = getStaged();
                    if (isEqual(staged, meta.previous)) {
                        return [
                            2,
                            false
                        ];
                    }
                    setMeta(_object_spread_props(_object_spread({}, meta), {
                        isSaving: true
                    }));
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        props.onSave(staged)
                    ];
                case 2:
                    _state.sent();
                    setMeta(_object_spread_props(_object_spread({}, meta), {
                        error: null,
                        isSaving: false,
                        previous: staged,
                        savedAt: new Date()
                    }));
                    return [
                        2,
                        true
                    ];
                case 3:
                    e = _state.sent();
                    console.error(e);
                    setMeta(_object_spread_props(_object_spread({}, meta), {
                        error: e,
                        isSaving: false
                    }));
                    return [
                        2,
                        true
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        getStaged,
        meta,
        meta.isSaving,
        meta.previous,
        props.onSave
    ]);
    useInterval(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        save()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), meta.disabled ? null : interval);
    var onBlur = useCallback(function(event) {
        if (!isNamedElement(event.target)) return;
        // blur guaranteed to happen before a change focus event:
        // https://w3c.github.io/uievents/#events-focusevent
        setFocused(null);
    }, [
        setFocused
    ]);
    var onFocus = useCallback(function(event) {
        if (!isNamedElement(event.target)) return;
        setFocused(event.target.name);
    }, [
        setFocused
    ]);
    useEffect(function() {
        if (!observerRef.current) return;
        var form = observerRef.current.closest('form');
        if (!form) {
            throw new Error("FormAutosaveObserver must be a descendant of a form element");
        }
        // Use capture phase for all events here (ie last argument `true`)
        form.addEventListener('blur', onBlur, true);
        form.addEventListener('focus', onFocus, true);
        return function() {
            form.removeEventListener('blur', onBlur, true);
            form.removeEventListener('focus', onFocus, true);
        };
    }, [
        observerRef.current,
        onBlur,
        onFocus
    ]);
    var _props_children1;
    return /*#__PURE__*/ _jsx(StyledFormAutosaveObserver, {
        ref: observerRef,
        children: (_props_children1 = (_props_children = props.children) === null || _props_children === void 0 ? void 0 : _props_children.call(props, _object_spread_props(_object_spread({}, meta), {
            focused: focused,
            save: save
        }))) !== null && _props_children1 !== void 0 ? _props_children1 : null
    });
};
FormAutosaveObserver.displayName = 'FormAutosaveObserver';

//# sourceMappingURL=FormAutosaveObserver.js.map